export default __webpack_public_path__ + "static/Stimulant-6de14e0cea35fced13a21c477b1670e2.png";